import React from "react"
import { Accordion as BSAccordion } from "react-bootstrap"

import classNames from "classnames"

import { useEvent } from "shared/lib/useEvent"
import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { AccordionItemProps } from "./AccordionItem"

function AccordionButtonComponent<
  T = void,
  P = void,
  ElementType extends HTMLElement = HTMLDivElement
>({
  ButtonRenderer,
  eventKey,
  tab,
  payload,
  isExpanded,
  isDisabled,
  isSelected,
  onSelect,
  onExpand
}: AccordionItemProps<T, P, ElementType>) {
  const handleSelect = useEvent(() => {
    onSelect?.(eventKey)
  })

  const handleExpand = useEvent(() => {
    onExpand?.(eventKey)
  })

  if (ButtonRenderer) {
    return (
      <div className="accordion-button accordion-button-flush">
        <ButtonRenderer
          option={tab}
          payload={payload}
          isSelected={isSelected}
          isExpandable={!!tab.content}
          isExpanded={isExpanded}
          isDisabled={isDisabled}
          aria-controls={`${eventKey}-body`}
          onSelect={onSelect ? handleSelect : undefined}
          onExpand={onExpand ? handleExpand : undefined}
        />
      </div>
    )
  }
  const { title } = tab

  return (
    <BSAccordion.Button
      aria-expanded={isExpanded}
      aria-controls={`${eventKey}-body`}
      disabled={isDisabled || !tab.content}
      className={classNames({ disabled: isDisabled || !tab.content })}
    >
      <div className="accordion-button__title">{title}</div>
      <Icon
        name={IconName.SMALL_CARET_UP}
        size={IconSize.XXS}
        className="accordion-button__indicator"
      />
    </BSAccordion.Button>
  )
}

export const AccordionButton = React.memo(
  AccordionButtonComponent
) as typeof AccordionButtonComponent
